// extracted by mini-css-extract-plugin
export default {"card":"eventCard_card__lvlwP"};